import { useOOCReport as useProgrammaticOOCReport } from 'components/pages/Deals/ProgrammaticDeals/OOCReport/useOOCReport';
import { OOCReportButton } from 'components/pages/Deals/utils/OOC/OOCReportButton';
import { OOCReportButtonProps } from 'components/pages/Deals/utils/OOC/OOCReportButton.types';

type OOCProgrammaticReportButtonProps = Omit<OOCReportButtonProps, 'oocFramesCount'> & {
  isNGDealFilterApplied?: boolean;
};

const OOCProgrammaticReportButton = ({
  isNGDealFilterApplied,
  onClick,
  dismountedSearch,
}: OOCProgrammaticReportButtonProps): React.ReactElement => {
  const { totalOOCDealLineCount } = useProgrammaticOOCReport();

  return (
    <OOCReportButton
      oocFramesCount={!isNGDealFilterApplied ? totalOOCDealLineCount : 0}
      onClick={onClick}
      dismountedSearch={dismountedSearch}
    />
  );
};

export default OOCProgrammaticReportButton;
